<template>
  <div> 
    <DataTable
      :key="dataTableKey"
      :value="data"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="10"
      :rowHover="true"
      :selection.sync="selectedData"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} User Login Histories"
      :scrollable="true"
      scrollHeight="400px"
      :style="{ 'width': '100%' }"
    >
      <template #empty> No {{ name }} found. </template>
      <template #loading> Loading {{ name }} data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="loginDate"
        header="Login Date"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.loginDate }}
          </div>
        </template>
      </Column>
      <Column
        field="user"
        header="User"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="notes"
        header="Notes"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.notes }}
          </div>
        </template>
      </Column>
    </DataTable>

  </div>
</template>

<script>

export default {
  props: [
    'data',
    'name',
    'loading',
    'globalFilter',
    'user'
  ],
  data: () => ({
    selectedData: null,
    dataTableKey: 0,
    filters: {
      global: ''
    }
  }),
  watch: {
    data(val) {
      this.dataTableKey++
    },
    globalFilter(val) {
      this.filter.global = val
      this.dataTableKey++
    }
  },
  created() {
    this.filters.global = this.$route.query.search
  }
}
</script>

<style>

</style>